import { render, staticRenderFns } from "./AddPage.vue?vue&type=template&id=fc092702&scoped=true"
import script from "./AddPage.vue?vue&type=script&lang=js"
export * from "./AddPage.vue?vue&type=script&lang=js"
import style0 from "./AddPage.vue?vue&type=style&index=0&id=fc092702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc092702",
  null
  
)

export default component.exports